var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectListActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "21px",
    viewBox: "0 0 23 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A861E019-2E6C-40BC-9604-E58A66CEE6DA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Projects-List",
    transform: "translate(-17.000000, -316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-list-active",
    transform: "translate(18.000000, 317.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, -0.000000)",
    fillRule: "nonzero",
    stroke: "#035FB2",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3013051,14.6986568 L0.751964198,14.6986568 C0.548192352,14.6986568 0.372031756,14.775938 0.223153215,14.9301591 C0.0744392708,15.0843375 -9.59232693e-14,15.2674483 -9.59232693e-14,15.4786382 L-9.59232693e-14,18.2201467 C-9.59232693e-14,18.4310378 0.0744392708,18.6141486 0.223194364,18.7683697 C0.372196354,18.9225908 0.548439249,19 0.752005348,19 L20.3013462,19 C20.5047889,19 20.6812375,18.9226334 20.8301161,18.7683697 C20.97883,18.6141913 21.0533516,18.4310805 21.0533516,18.2201467 L21.0533516,15.4786382 C21.0533516,15.2674483 20.97883,15.0843375 20.8301161,14.9301164 C20.6811964,14.7758954 20.5047477,14.6986568 20.3013051,14.6986568 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3013051,7.35567715 L0.751964198,7.35567715 C0.548192352,7.35567715 0.372031756,7.43287515 0.223153215,7.58722845 C0.0744392708,7.74149641 -9.59232693e-14,7.92427087 -9.59232693e-14,8.13538113 L-9.59232693e-14,11.2543251 C-9.59232693e-14,11.465478 0.0744392708,11.6483378 0.223194364,11.8025631 C0.372196354,11.9567884 0.548439249,12.0341997 0.752005348,12.0341997 L20.3013462,12.0341997 C20.5047889,12.0341997 20.6812375,11.956831 20.8301161,11.8025631 C20.97883,11.6483805 21.0533516,11.4655207 21.0533516,11.2543251 L21.0533516,8.13538113 C21.0533516,7.92427087 20.97883,7.74153909 20.8301161,7.58722845 C20.6811964,7.43283247 20.5047477,7.35567715 20.3013051,7.35567715 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8300749,0.231465949 C20.6812375,0.0773260141 20.5047889,-9.29034627e-13 20.3013051,-9.29034627e-13 L0.751964198,-9.29034627e-13 C0.548192352,-9.29034627e-13 0.372031756,0.0773260141 0.223153215,0.231465949 C0.0744392708,0.385819257 -9.59232693e-14,0.568679064 -9.59232693e-14,0.779831998 L-9.59232693e-14,3.89869057 C-9.59232693e-14,4.11001421 0.0744392708,4.29278866 0.223194364,4.44705662 C0.372196354,4.60140993 0.548439249,4.67852257 0.752005348,4.67852257 L20.3013462,4.67852257 C20.5047889,4.67852257 20.6812375,4.60140993 20.8301161,4.44705662 C20.97883,4.29278866 21.0533516,4.11001421 21.0533516,3.89869057 L21.0533516,0.779831998 C21.0533516,0.568679064 20.9787889,0.38594728 20.8300749,0.231465949 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#035FB2",
    x: 0,
    y: -4.4408921e-16,
    width: 6,
    height: 4.47058824
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#035FB2",
    x: 0,
    y: 7.82352941,
    width: 5,
    height: 4.47058824
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#035FB2",
    x: 0,
    y: 14.5294118,
    width: 11,
    height: 4.47058824
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectListActive);
export default __webpack_public_path__ + "static/media/Project-list-active.d8c86037a47e33bf72d52ccaca53585c.svg";
export { ForwardRef as ReactComponent };